import { GoogleGenerativeAI } from "@google/generative-ai";
import { OPENAI_KEY } from "./constants";

if (!OPENAI_KEY) {
  console.error("Gemini API Key is missing! Ensure REACT_APP_OPENAI_KEY is set in your .env and RESTART your server.");
}

const genAI = new GoogleGenerativeAI(OPENAI_KEY as string);

// Updated to the latest stable high-performance model
export const textModel = genAI.getGenerativeModel({
  model: "gemini-1.5-pro",
  generationConfig: {
    temperature: 0.7, // Slightly lower for more precise movie recommendations
  },
});
